import {
    INVOICE_GRID_DATA,
    INVOICE_GRID_ERROR,
    INVOICE_GRID_LOADING,
    INVOICE_GRID_PAGE_CHANGE,
    INVOICE_GRID_STATE_CHANGE,
} from "../constants";
import { authExpire } from "../../auth/actions";
import { makePrivateApiCall } from "utilities/dist/api";

export const loadInvoiceGridPage = (state, grid) => dispatch => {
    let { lastRow, sortModel, filterModel, customerId } = state;

    dispatch({
        type: INVOICE_GRID_LOADING,
    });

    const params = {
        endRow: grid.endRow,
        filterModel,
        sortModel,
        startRow: grid.startRow,
        customerId,
    };

    return makePrivateApiCall({
        url: "/invoice/grid",
        method: "get",
        params,
    })
        .then(res => {
            if (res.data) {
                const invoices = res.data.rows;
                lastRow = res.data.count;

                grid.successCallback(invoices, lastRow);

                dispatch({
                    type: INVOICE_GRID_DATA,
                    payload: { invoices, lastRow },
                });
            }
        })
        .catch(err => {
            grid.failCallback(err);

            if (err.response && err.response.status === 401) {
                return dispatch(authExpire());
            }

            dispatch({
                type: INVOICE_GRID_ERROR,
                payload: err.message,
            });
        });
};

export const changeInvoiceGridPage = page => {
    return {
        type: INVOICE_GRID_PAGE_CHANGE,
        payload: page,
    };
};

export const changeInvoiceGridState = gridState => dispatch =>
    dispatch({
        type: INVOICE_GRID_STATE_CHANGE,
        payload: gridState,
    });

export const searchInvoice = async invoiceId => {
    const params = {
        filterModel: {
            number: {
                filterType: "number",
                type: "equals",
                filter: invoiceId,
            },
        },
    };

    return makePrivateApiCall({
        url: "/invoice/grid",
        method: "get",
        params,
    })
        .then(res => res.data)
        .catch(() => []);
};
